import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";
import { Product } from "../../../../models/Product";
import { defer } from "../../../../utils/script";
import CartItem from "./components/CartItem";
import { EVENTS, callEvent } from "../../../../utils/event";
// eslint-disable-next-line no-unused-vars
import { PriceTag } from "../../../../models/PriceTag";
// eslint-disable-next-line no-unused-vars
import { PriceSaving } from "../../../../models/PriceSaving";

export default class ProductSummary extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    listProduct = [],
    isRFQOrder,
    isView = false,
    onSelect = () => { }
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("ProductSummary", {
        "is-view": isView
      })
    }, true, defaultLoading);
    this.listProduct = listProduct;
    this.isRFQOrder = isRFQOrder;
    this.isView = isView;
    /** @type {CartItem} */
    this.cartNormal = undefined;
    /** @type {CartItem} */
    this.cartRFQ = undefined;
    this.onSelect = onSelect;
    this.defaultLoading = defaultLoading;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "ProductSummary");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.cartNormal = new CartItem({ parent: $(`.shopping-cart .ready-to-checkout`, this.element), title: "checkout_readyToCheckout", defaultLoading: this.defaultLoading });
    this.cartRFQ = new CartItem({ parent: $(`.shopping-cart .request-quotation`, this.element), title: "checkout_priceToBeProvided", note: "checkout_priceToBeProvidedNotice", defaultLoading: this.defaultLoading });
    this.updateData();
  }

  /** @param {ProductSummary} _params */
  updateAttributes(_params = {}) {
    defer(() => this.element, () => {
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
      });
      this.updateData()
    });
  }

  updateData() {
    defer(() => (this.cartNormal && this.cartRFQ), () => {
      let listProductNormal = this.listProduct.filter(item => item.type !== Product.TYPE_PRODUCT.RFQ.id);
      let listProductRFQ = this.listProduct.filter(item => item.type === Product.TYPE_PRODUCT.RFQ.id);

      if (this.isView && this.isRFQOrder) {
        $(".shopping-cart .ready-to-checkout", this.element).addClass("hide");
        $(this.element).addClass("is-rfq");
      } else {
        if (this.isView) {
          listProductNormal = listProductNormal.filter(item => item.type !== Product.TYPE_PRODUCT.UNSELECT.id);
        }
        if (listProductNormal.length > 0) {
          this.cartNormal.updateAttributes({
            details: listProductNormal,
            isView: this.isView,
            hideSelect: this.isView,
            onSelect: this.onSelect,
            onChange: this.onChange,
          })
          $(".shopping-cart .ready-to-checkout", this.element).removeClass("hide");
        } else {
          $(".shopping-cart .ready-to-checkout", this.element).addClass("hide");
        }
        $(this.element).removeClass("is-rfq");
      }
      if (this.isView && !this.isRFQOrder) {
        $(".shopping-cart .request-quotation", this.element).addClass("hide");
      } else {
        if (listProductRFQ.length > 0) {
          this.cartRFQ.updateAttributes({
            details: listProductRFQ,
            isView: this.isView,
            hideSelect: true,
            onChange: this.onChange,
          })
          $(".shopping-cart .request-quotation", this.element).removeClass("hide");
        } else {
          $(".shopping-cart .request-quotation", this.element).addClass("hide");
        }
      }
    })
  }

  getProductsSelected() {
    let result = [];
    defer(() => this.cartNormal, () => {
      result = this.cartNormal.getProductsSelected();
    })
    return result;
  }

  getOtherDelivery() {
    let result = false;
    defer(() => this.cartNormal, () => {
      result = this.cartNormal.getOtherDelivery();
    })
    return result;
  }

  getCartNormalLength() {
    let result = 0;
    defer(() => this.cartNormal, () => {
      result = this.cartNormal.carts.length;
    })
    return result;
  }

  getCartRFQLength() {
    let result = 0;
    defer(() => this.cartRFQ, () => {
      result = this.cartRFQ.carts.length;
    })
    return result;
  }

  /** @param {[PriceTag]} priceTags */
  setLowestPrice(priceTags = []) {
    let listProducts = this.cartNormal.details;
    if (!listProducts?.length) return;
    for (let index = 0; index < listProducts.length; index++) {
      const product = listProducts[index];
      let temp = priceTags.find(item => item.id === product.pid || item.id === product.id);
      callEvent(EVENTS.UPDATE_PRICE_TAGS + product.id, {
        product: product,
        tags: temp?.tags || []
      });
    }
  }

  /** @param {[PriceSaving]} priceTags */
  setSavingPrice(savings = []) {
    let listProducts = this.cartNormal.details;
    if (!listProducts?.length) return;
    for (let index = 0; index < listProducts.length; index++) {
      const product = listProducts[index];
      let temp = savings.find(item => item.id === product.pid || item.id === product.id);
      callEvent(EVENTS.UPDATE_PRICE_SAVINGS + product.id, {
        product: product,
        saving: temp,
      });
    }
  }
}